import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ChangeCreditCardForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeCreditCard, requestAddCreditCard} from "../../actions/AccountApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class ChangeCreditCardFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      selectedId: "current",
      errors: [] 
    }
  }

  handleSubmit(values) {
    if (this.state.selectedId === "current") {
      this.props.cancelChangeCreditCard();
    } else {
      return this.props.assignDefaultPaymentMethod({accountId: this.props.accountId, paymentMethodId: this.state.selectedId})
        .then((response) => {
          if (response.data.assignDefaultPaymentMethod.errors.length <= 0) {
            this.props.cancelChangeCreditCard();
          } else {
            let errors = createValidationErrors(response.data.assignDefaultPaymentMethod.errors);
            this.setState({errors: errors});            
          }
        })
        .catch((err) => {
          this.setState({errors: createErrors(err)});
        });      
    }
  }

  handleCancel() {
    this.props.cancelChangeCreditCard();
  }

  handleAddCard() {
    this.props.cancelChangeCreditCard();
    this.props.requestAddCreditCard(this.props.accountId);
  }

  handleSelectCardId(id) {
    this.setState({
      selectedId: id
    })
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    const pms = fromJS(data.billingPaymentMethods);
    let defaultPaymentMethod = pms.find(x => x.get("default") === true);
    return (
      <Form
        errors={this.state.errors}
        selectedPaymentMethod={defaultPaymentMethod}
        paymentMethods={pms}
        selectedId={this.state.selectedId}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onAddCard={this.handleAddCard.bind(this)}
        onSelect={this.handleSelectCardId.bind(this)}
        />
    )
  }
}

const CUSTOMER_PAYMENT_METHODS = gql`
  query billingPaymentMethods($accountId:ID!) {
    billingPaymentMethods(accountId:$accountId) {
      paymentMethodId
      type
      cardBrand
      cardExpYear
      cardExpMonth
      cardLast4
      default
      addedAt
    } 
  }
`

const ASSIGN_DEFAULT_CARD = gql`
  mutation assignDefaultPaymentMethod($data: AssignDefaultPaymentMethodInput!) {
    assignDefaultPaymentMethod(input: $data) {
      errors { key message }
    }
  }
`

const withQueries = compose(
  graphql(CUSTOMER_PAYMENT_METHODS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(ASSIGN_DEFAULT_CARD, {
    props: ({ mutate }) => ({
      assignDefaultPaymentMethod: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelChangeCreditCard, requestAddCreditCard})(withQueries(ChangeCreditCardFormContainer));